<template>
  <div
    class="navbar-wrapper"
    :class="user.isLoginToTheCampaign && 'navbar-campaign-style'"
    :style="{
      display: user.isGameStart || isJoinToTheCampaign ? 'none' : 'flex',
      zIndex: user.isNew ? '1000' : '999',
    }"
  >
    <div class="navbar-container">
      <NavbarItem />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  isActiveSpin: { type: Boolean, default: false },
  isActiveEarn: { type: Boolean, default: false },
  isActiveHome: { type: Boolean, default: false },
  isActiveChart: { type: Boolean, default: false },
  isActiveProfile: { type: Boolean, default: false },
})

const user = useUserStore()

const isJoinToTheCampaign = computed(() => user.isLoginToTheCampaign)
</script>

<style lang="scss" scoped>
.navbar-wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background: linear-gradient(180deg, rgba(0, 18, 52, 0) 0%, #001234 100%);
  z-index: 999;
  height: 100px;
  max-width: $sm;
  margin: 0 auto;
}
.navbar-campaign-style {
  background-color: unset;
}

.navbar-container {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 999;
  max-width: $sm;
  margin: 0 auto;
  width: 92%;
  bottom: 15px;
  background-color: #3a3d42;
  height: 55px;
  border-radius: 18px;
}
</style>
